import React from "react";
import "./termsConditions.css";

const TermsConditions = () => {
  return (
    <div className="tc-wrapper">
      <div className="tc-hero">
        <h1>Terms and Conditions</h1>
      </div>

      <div className="tc-container">
        <section className="tc-section">
          <h3>1. Booking and Confirmation</h3>
          <p>
            All bookings must be confirmed in writing and accompanied by a
            completed booking form and a non-refundable deposit. The booking
            will be considered confirmed only upon receipt of this deposit and
            a written confirmation from <strong>BR Travel</strong>.
          </p>
        </section>

        <section className="tc-section">
          <h3>2. Payment Terms</h3>
          <ul>
            <li>A non-refundable deposit (typically 25%) is required to secure your booking.</li>
            <li>The balance is due no later than 60 days before the trip start date.</li>
            <li>Bookings made within 60 days of departure require full payment at the time of booking.</li>
            <li>Payment can be made via bank transfer or other accepted payment methods communicated in advance.</li>
          </ul>
        </section>

        <section className="tc-section">
          <h3>3. Cancellations and Refunds</h3>
          <ul>
            <li>Cancellations must be submitted in writing.</li>
            <li>More than 60 days before departure: Deposit retained.</li>
            <li>59–30 days before departure: 50% of total cost.</li>
            <li>Less than 30 days before departure: 100% of total cost.</li>
            <li>No refunds will be given for unused services or portions of the trip.</li>
            <li>Refunds, where applicable, will be processed within 45 days of written notice.</li>
          </ul>
        </section>

        <section className="tc-section">
          <h3>4. Changes by the Client</h3>
          <ul>
            <li>Requests to modify bookings must be made in writing.</li>
            <li>Changes are subject to availability and administrative fees.</li>
            <li>Major changes may be treated as cancellations.</li>
          </ul>
        </section>

        <section className="tc-section">
          <h3>5. Changes by BR Travel</h3>
          <p>
            We reserve the right to make changes due to unforeseen circumstances.
            If significant changes are required, clients will be notified as soon
            as possible. If the trip is cancelled by us, a full refund will be offered.
          </p>
        </section>

        <section className="tc-section">
          <h3>6. Travel Insurance</h3>
          <ul>
            <li>Travel insurance is highly recommended for all travelers, but not mandatory.</li>
            <li>We strongly advise securing a comprehensive policy that includes coverage for trip cancellation, interruption, medical emergencies, COVID-19, baggage loss, and personal liability.</li>
            <li>BR Travel is not responsible for any costs or losses incurred as a result of not having appropriate travel insurance.</li>
            <li>It is the traveler’s responsibility to ensure the insurance purchased suits their specific needs.</li>
          </ul>
        </section>

        <section className="tc-section">
          <h3>7. Health and Safety</h3>
          <p>
            Travelers must be in good health and capable of undertaking the itinerary.
            BR Travel reserves the right to refuse participation to anyone deemed unfit.
            All travelers must comply with local health and safety regulations.
          </p>
        </section>

        <section className="tc-section">
          <h3>8. Visas and Travel Documents</h3>
          <p>
            It is the responsibility of each traveler to obtain and carry valid
            passports, visas, vaccination certificates, and any other required
            documentation. BR Travel provides general guidance but is not responsible
            for denied boarding or entry.
          </p>
        </section>

        <section className="tc-section">
          <h3>9. Liability and Responsibility</h3>
          <p>
            BR Travel acts only as an agent for hotels, transport companies, and
            other service providers. We are not liable for injury, loss, damage,
            accident, delay, or irregularity caused by third parties or force majeure events.
            Participation in the trip implies acceptance of inherent travel risks.
          </p>
        </section>

        <section className="tc-section">
          <h3>10. Complaints and Disputes</h3>
          <p>
            Any complaints must be reported immediately to our local representative
            or team leader. Unresolved issues must be submitted in writing within
            30 days of trip completion. Disputes will be governed by the laws of India.
          </p>
        </section>

        <section className="tc-section">
          <h3>11. Use of Images and Testimonials</h3>
          <p>
            BR Travel may use photos or feedback from the trip for promotional purposes
            unless otherwise requested in writing.
          </p>
        </section>

        <section className="tc-section">
          <h3>12. Data Protection</h3>
          <p>
            Personal information will be handled in accordance with data protection
            regulations and used solely for the purpose of trip management and communication.
          </p>
        </section>

        <section className="tc-section">
          <h3>13. Special Conditions for Group Departures</h3>
          <ul>
            <li>Group departures are subject to a minimum number of participants.</li>
            <li>If the minimum number is not met, BR Travel reserves the right to cancel or reschedule the trip.</li>
            <li>In the event of cancellation due to low participation, a full refund will be offered or an alternative date will be proposed.</li>
            <li>Group-specific discounts or benefits may vary and are only valid for the designated departure dates.</li>
            <li>Travelers are expected to adhere to the group schedule and cooperate with the tour leader and fellow participants.</li>
            <li>Rooming is based on double occupancy unless otherwise specified. Single supplements may apply.</li>
          </ul>
        </section>

        <section className="tc-section tc-last">
          <h3>14. Acceptance of Terms</h3>
          <p>
            Payment of deposit or full amount constitutes acceptance of these Terms and Conditions.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsConditions;

